import React from 'react'

const MUTED = '#78716C'

/**
 * The heading of a warehouse queue screen: its name, one line on what is in
 * it, and the screen's actions (children) on the right.
 */
function QueueHeader({ title, description, children }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
      <div>
        <h1 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '4px' }}>{title}</h1>
        <p style={{ color: MUTED, fontSize: '14px' }}>{description}</p>
      </div>
      {children}
    </div>
  )
}

export default QueueHeader
